import * as React from "react";
import { FC, useEffect, useState } from "react";
import { Feature } from "ol";
import { useDemoContext } from "./DemoContext";
import { Collapsible } from "./Collapsible";

export interface IDemoSearchProps {
    filteredByText: Feature[];
    onApplySearchResults: (currentFilters: any, searchFieldValue: string) => void;
    onSearchUpdate: (currentFilters: any, text: string) => void;
}
export const DemoSearch: FC<IDemoSearchProps> = (props: IDemoSearchProps) => {
    const [searchFieldValue, setSearchFieldValue] = useState("");

    const { searchFieldList, setSearchFieldList, filterValues } = useDemoContext();

    const maxResults = 7;

    useEffect(() => {
        if (props.filteredByText && props.filteredByText.length) {
            const newoptions = props.filteredByText
                .slice(0, maxResults)
                .map((result) => result && result.values_ && result.values_.PLACENAME);
            setSearchFieldList(newoptions);
        }
    }, [props.filteredByText]);

    const onSearchFieldChange = (e) => {
        setSearchFieldValue(e.target.value);
        props.onSearchUpdate(filterValues, e.target.value);
    };

    return (
        <Collapsible title="Meklēšana" defaultCollapsed={true}>
            <div className="list search">
                <input
                    type="text"
                    list="datalist"
                    title="meklēt..."
                    value={searchFieldValue}
                    placeholder="meklēt..."
                    onChange={(e) => onSearchFieldChange(e)}
                />
                <datalist id="datalist">
                    {searchFieldList.map((option, i) => {
                        return <option key={"option-" + i + option} value={option}></option>;
                    })}
                </datalist>
                <button
                    title={"select-objects"}
                    onClick={() => props.onApplySearchResults(filterValues, searchFieldValue)}
                >
                    Atlasīt objektus
                </button>
                <span>{props.filteredByText && props.filteredByText.length}</span>
            </div>
        </Collapsible>
    );
};
